import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import i18n from 'i18next';
import config from 'utils/config';
import { COACH_AI_ROUTE, PROFILE_ROUTES } from 'utils/routes';
import { openMindsetAgentWithMessage } from './openMindsetAgentWithMessage';
import { useCheckIfWeShowAgentInPage } from './visibility/useCheckIfWeShowAgentInPage';
export function useOpenCoachAgent() {
  var _useCheckIfWeShowAgen = useCheckIfWeShowAgentInPage(),
    hasAgentOnPage = _useCheckIfWeShowAgen.hasAgentOnPage,
    isSettled = _useCheckIfWeShowAgen.isSettled;
  var navigate = useNavigate();
  var triggerCoachAgent = useCallback(function (_ref) {
    var skillName = _ref.skillName,
      coachingContext = _ref.coachingContext;
    if (!hasAgentOnPage) {
      navigate(config.showAgentInHelixPages ? PROFILE_ROUTES.skills : COACH_AI_ROUTE);
    }
    openMindsetAgentWithMessage(i18n.t('coach_ai_thread_prompt_coaching', {
      skillName: skillName
    }), {
      threadTitle: skillName ? i18n.t('coach_ai_thread_title_coaching', {
        skillName: skillName
      }) : '',
      coachingContext: coachingContext
    });
  }, [hasAgentOnPage, navigate]);
  return {
    triggerCoachAgent: triggerCoachAgent,
    isReady: isSettled
  };
}